/* WWC search synonyms (31 Oct 2026). Search & Discovery has no synonyms feature on this store, so the theme expands
   the query itself: q=("hard hat" OR helmet OR "safety helmet") with other words ANDed. The typed phrase always goes first
   so main-search / predictive-search can show it back (snippets/wwc-syn-display.liquid). Source: synonyms.txt. */
window.WWCSYN = window.WWCSYN || (function () {
  const G = [{"k":["hi vis","hi-vis","hi viz","hi-viz","hivis","hiviz","high vis","high-vis","high visibility","high viz"]},{"k":["hard hat","hard hats","hardhat","hardhats","safety helmet","safety helmets","construction helmet"],"s":["hard hat","helmet","safety helmet"]},{"k":["safety boots","work boots","safety footwear"]},{"k":["steel toe","steel toe cap","steel toecap","steel toe caps","steel toecaps"]},{"k":["trousers","pants","work trousers","work pants","trowsers"]},{"k":["jacket","coat","jaket"]},{"k":["overalls","coveralls","coverall","boilersuit","boilersuits","boiler suit","boiler suits"]},{"k":["polo","polos","polo shirt","polo shirts"]},{"k":["hoodie","hoodies","hoody","hooded sweatshirt","hooded top"]},{"k":["ear defenders","ear defender","ear muffs","earmuffs","ear muff"]},{"k":["safety glasses","safety specs","safety spectacles"]},{"k":["goggles","safety goggles"]},{"k":["rainwear","waterproofs","rain gear","rain suit"]},{"k":["waterproof jacket","rain jacket","rain coat","raincoat"]},{"k":["hi vis vest","hi-vis vest","high vis vest","hi vis waistcoat","hi-vis waistcoat","high vis waistcoat","safety vest"]},{"k":["chef whites","chef jacket","chefs jacket","chef's jacket","chef coat"]},{"k":["bodywarmer","body warmer","gilet","gilets"]},{"k":["t-shirt","tshirt","t shirt","tee shirt"]},{"k":["womens","women's","ladies","ladies'"]},{"k":["kids","childrens","children's","junior"]},{"k":["wellington","wellingtons","wellies","wellington boots"]},{"k":["tunic","healthcare tunic","carer tunic","care worker tunic"]},{"k":["zepelin","zeplin","zeppelin"]},{"k":["gloves"],"s":["gauntlets"],"one":1},{"k":["snikers","snicker"],"s":["snickers"],"one":1},{"k":["port west"],"s":["portwest"],"one":1},{"k":["tee jay","teejays","tee jay's"],"s":["tee jays"],"one":1},{"k":["eye protection"],"s":["safety glasses","goggles"],"one":1}];
  const M = new Map();
  G.forEach((g) => g.k.forEach((t) => M.set(t, g.one ? [t].concat(g.s) : g.s || g.k)));
  const qt = (t) => (/[\s'-]/.test(t) ? `"${t}"` : t);
  function expand(q) {
    if (!q || /\bOR\b|[()":]/.test(q)) return q;
    // o keeps the buyer's own case for the first alternative (shown back on /search); w is for matching.
    const o = q.replace(/[\u2019`]/g, "'").split(/\s+/).filter(Boolean);
    const w = o.map((x) => x.toLowerCase());
    const out = [];
    let hit = false;
    for (let i = 0; i < w.length; ) {
      let n = Math.min(4, w.length - i);
      for (; n > 0; n--) {
        const p = w.slice(i, i + n).join(' ');
        if (M.has(p)) {
          const alts = [o.slice(i, i + n).join(' ')].concat(M.get(p).filter((t) => t !== p));
          out.push('(' + alts.map(qt).join(' OR ') + ')');
          i += n;
          hit = true;
          break;
        }
      }
      if (!n) out.push(o[i++]);
    }
    return hit ? out.join(' ') : q;
  }
  return { expand };
})();

if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.cachedMap = new Map();
        this.focusElement = this.input;
        this.searchContent = this.querySelector('.search__content');
        this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
        this.header = document.querySelector('header');
        this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');

        this.isHeaderSearch = this.closest('header') !== null;

        this.states = {
          OPEN: 'predictive-search-open',
          LOADING: 'btn--loading',
          SEARCH_OPEN: 'search-open'
        };
      }

      connectedCallback() {
        // The header and the search page re-render in the theme editor: the document listeners must go with them.
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.resetButton.addEventListener('click', this.clear.bind(this), { signal });
        this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 200), { signal });
        this.input.addEventListener('focus', this.onFocus.bind(this), { signal });
        document.addEventListener('click', this.handleClickOutside.bind(this), { signal });
        this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this), { signal });
        this.form?.addEventListener('submit', this.onSubmit.bind(this), { signal });

        // WWC search (Draft 116): arrow keys / Enter / aria-activedescendant over the dropdown options.
        window.WWCPS?.bindKeys(this);

        document.addEventListener(
          'menu-drawer:open',
          () => {
            this.classList.remove('predictive-search-open');
            document.body.classList.remove('search-open');
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }
      get resetButton() {
        return this.querySelector('button[type="reset"]');
      }

      get searchProductTypes() {
        return this.querySelector('.search__types select');
      }

      get form() {
        return this.querySelector('form');
      }

      get headerCollapseOnScroll() {
        return this.header.dataset.collapseOnScroll === 'true';
      }

      onFocus(event) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(this.header.getBoundingClientRect().bottom)}px`
        );
        if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
          document.body.classList.add('search-open');
          this.toggleNavButtonVisibility(false);
        }

        if (!this.searchRecommendationEmpty) {
          this.searchContent.classList.remove('hidden');
        }
        this.classList.add('predictive-search-open');
        if (this.getQuery().length === 0) {
          if (this.searchRecommendationEmpty) {
            this.searchContent.classList.add('hidden');
          }
          return;
        }
        const url = this.setupURL().toString();
        // Reopening shows the results of a query the buyer already searched: not a search update.
        this.renderSection(url, { isReopen: true });
      }

      getQuery() {
        return this.input.value.trim();
      }

      clear(event = null) {
        event?.preventDefault();
        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
        this.toggleSearchState(false);
      }

      handleProductTypeChange(evt) {
        const query = this.getQuery();
        if (query.length > 0) {
          const url = this.setupURL().toString();
          this.renderSection(url);
        }
      }

      onSubmit(event) {
        const query = this.getQuery();
        if (query.length === 0) return;
        if (query.startsWith('product_type:')) return;
        const productType = this.searchProductTypes?.value;
        // WWC search synonyms: the results page gets the expanded query; it shows the typed words back.
        const expanded = window.WWCSYN.expand(query);
        if (!productType && expanded === query) return;
        event.preventDefault();
        const params = new URLSearchParams(new FormData(this.form));
        params.set('q', productType ? `product_type:${productType} AND ${expanded}` : expanded);
        params.set('options[prefix]', 'last');
        window.location.href = `${this.form.getAttribute('action')}?${params.toString()}`;
      }

      // WWC search (Draft 116): typo/synonym normalising (hiviz -> hi vis, jaket -> jacket, sizes and places stripped).
      getSentQuery(raw = this.getQuery()) {
        const n = window.WWCPS?.norm(raw);
        return n && n.q ? n.q : raw;
      }

      setupURL(override) {
        const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
        let search_term = window.WWCSYN.expand(override || this.getSentQuery());
        if (this.searchProductTypes && this.searchProductTypes.value != '') {
          // URLSearchParams encodes the value itself: pre-encoding the term double-encoded it.
          search_term = `product_type:${this.searchProductTypes.value} AND ${search_term}`;
        }
        url.searchParams.set('q', search_term);
        url.searchParams.set('resources[limit]', 8);
        url.searchParams.set('resources[limit_scope]', 'each');
        // WWC search (Draft 116): suggestions, collections, pages and articles as well as products.
        url.searchParams.set('resources[type]', 'product,collection,page,article,query');
        // WWC search fix: match product codes (title, SKU, tags e.g. mpn:RX101) and partially typed codes.
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,vendor,tag');
        url.searchParams.set('resources[options][prefix]', 'last');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        // WWC search (Draft 116): a light dedicated results section instead of re-rendering the whole header.
        url.searchParams.set('section_id', 'wwc-predictive-search');
        return url;
      }

      onChange() {
        if (this.getQuery().length === 0) {
          this.clear();
          return;
        }
        const url = this.setupURL().toString();
        this.renderSection(url);
      }

      renderSection(url, { isReopen = false } = {}) {
        const searchUpdate = isReopen
          ? null
          : FoxTheme.storefrontEvents?.start(this, 'SearchUpdateEvent', {
              search: { query: this.getQuery() }
            });

        this.cachedMap.has(url)
          ? this.renderSectionFromCache(url, searchUpdate)
          : this.renderSectionFromFetch(url, searchUpdate);
      }

      renderSectionFromCache(url, searchUpdate) {
        this.fetchController?.abort();
        this.latestUrl = url;
        const responseText = this.cachedMap.get(url);
        (this.renderSearchResults(responseText), this.setAttribute('results', ''));
        searchUpdate?.resolve({ totalCount: this.getTotalResults() });
      }

      renderSectionFromFetch(url, searchUpdate) {
        this.setLoadingState(true);

        // WWC search fix: cancel the previous in-flight request and ignore late responses, so a slow
        // response for an earlier query (e.g. "rx10") can never overwrite the results for "rx101".
        this.fetchController?.abort();
        const controller = new AbortController();
        this.fetchController = controller;
        this.latestUrl = url;

        fetch(url, { signal: controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then((responseText) => {
            if (this.latestUrl !== url) return;
            this.renderSearchResults(responseText);
            // Only cache non-empty results: an empty answer is not kept for the rest of the page view.
            if (this.getTotalResults() > 0) this.cachedMap.set(url, responseText);
            searchUpdate?.resolve({ totalCount: this.getTotalResults() });
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            searchUpdate?.reject(error);
            console.error('Error fetching data: ', error);
            this.setAttribute('error', 'Failed to load data');
          })
          .finally(() => {
            if (this.fetchController === controller) this.setLoadingState(false);
          });
      }

      getTotalResults() {
        const results = document.getElementById(`PredictiveSearchResults-${FoxTheme.utils.getSectionId(this)}`);
        return Number(results?.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
      }
      renderSearchResults(responseText, fallbackFrom = null) {
        const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
        const targetElement = document.getElementById(id);

        if (targetElement) {
          const parser = new DOMParser();
          const parsedDoc = parser.parseFromString(responseText, 'text/html');
          const contentElement = parsedDoc.querySelector('[data-wwcps-results]') || parsedDoc.getElementById(id);

          if (contentElement) {
            this.searchContent?.classList.remove('hidden');
            targetElement.innerHTML = contentElement.innerHTML;
            this.enhanceResults(targetElement, fallbackFrom);

            if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
              document.body.classList.add('search-open');
              this.toggleNavButtonVisibility(true);
              this.classList.add('predictive-search-open');
            } else {
              this.classList.add('predictive-search-open');
            }
          } else {
            console.error(`Element with id '${id}' not found in the parsed response.`);
          }
        } else {
          console.error(`Element with id '${id}' not found in the document.`);
        }
      }

      // WWC search (Draft 116): add phrases, variation chips, collections and guides; retry a simpler query on 0 products.
      enhanceResults(targetElement, fallbackFrom) {
        const W = window.WWCPS;
        this.input?.setAttribute('aria-expanded', 'true');
        if (!W) return;
        W.bindKeys(this);
        const raw = this.getQuery();
        const n = W.norm(raw);
        let sent = targetElement.querySelector('[data-wwcps]')?.dataset.terms || n.q;
        // WWC search synonyms: notes and highlights use the buyer's words, not the OR clause.
        // data-terms arrives HTML-escaped twice (Shopify escapes search terms), so undo &quot; / &amp; for the link.
        const sentExpanded = sent.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
        if (/\sOR\s/.test(sent)) sent = n.q;
        try {
          W.enhance(targetElement, raw, n, sent);
          const all = targetElement.querySelector('.wwcps-all');
          if (all && sentExpanded !== sent) {
            all.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(sentExpanded)}&options%5Bprefix%5D=last`;
          }
        } catch (e) {
          console.error(e);
        }
        if (fallbackFrom) {
          const note = targetElement.querySelector('[data-wwcps-note]');
          if (note) {
            note.textContent = `No exact matches for "${fallbackFrom}". Showing results for "${sent}".`;
            note.hidden = false;
          }
          return;
        }
        if (this.getTotalResults() === 0) {
          const fq = W.fallbackQ(n);
          if (!fq) return;
          const url = this.setupURL(fq).toString();
          const startedFor = this.latestUrl;
          fetch(url)
            .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
            .then((text) => {
              if (this.latestUrl !== startedFor) return;
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const total = Number(doc.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
              if (total > 0) this.renderSearchResults(text, raw);
            })
            .catch(() => {});
        }
      }

      handleClickOutside(event) {
        const target = event.target;
        const shouldClose = this.isHeaderSearch
          ? !this.contains(target) &&
            ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
              target.classList.contains('header__search-close'))
          : !this.contains(target);

        if (shouldClose) {
          setTimeout(() => this.toggleSearchState(false));
        }
      }

      toggleSearchState(isOpen) {
        this.classList.toggle(this.states.OPEN, isOpen);
        this.input?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (!isOpen) this.input?.removeAttribute('aria-activedescendant');
        if (this.isHeaderSearch) {
          document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
          this.toggleNavButtonVisibility(!isOpen);
        }
        if (!isOpen && this.searchRecommendationEmpty) {
          this.searchContent?.classList.add('hidden');
        }
      }

      toggleNavButtonVisibility(isOpen) {
        this.toggleNavigationButton &&
          this.headerCollapseOnScroll &&
          this.toggleNavigationButton.classList.toggle('is-show', isOpen);
      }

      setLoadingState(isLoading) {
        if (isLoading) {
          this.setAttribute('loading', 'true');
          this.resetButton.classList.add(this.states.LOADING);
        } else {
          this.removeAttribute('loading');
          this.resetButton.classList.remove(this.states.LOADING);
          this.setAttribute('results', 'true');
        }
      }
    }
  );
}
